<ng-template #addRfiDialog>
  <div *ngIf="currentStep === 1">
    <div
      class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6 h-[49px]"
    >
      <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
        <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
          <h3 class="header-title">Request for Information (RFI)</h3>
          <span
            class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[14px] text-[#343A40] roboto font-semibold"
            >Project Brief</span
          >
        </div>
      </div>
      <div
        style="position: absolute; top: 10px; right: 36px; z-index: 50"
        (click)="closeDialog()"
      >
        <img
          src="assets/icons/cross-icon.svg"
          alt="cross icon"
          class="cursor-pointer !fixed"
        />
      </div>
    </div>
    <div class="px-[22px]">
      <app-brief-section></app-brief-section>
    </div>
    <div
      class="!pr-[32px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 sticky bottom-0 left-0 !bg-inherit"
    >
      <div class="!w-[100%] flex justify-end items-center">
        <button
          class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
          (click)="nextStep()"
        >
          Next
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="currentStep === 2">
    <div
      class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6 h-[49px]"
    >
      <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
        <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
          <h3 class="header-title">Request for Information (RFI)</h3>
          <span
            class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[14px] text-[#343A40] roboto font-semibold"
            >New RFI</span
          >
        </div>
      </div>
      <!-- Close Icon -->
      <div
        style="position: absolute; top: 10px; right: 36px; z-index: 50"
        (click)="closeDialog()"
      >
        <img
          src="assets/icons/cross-icon.svg"
          alt="cross icon"
          class="cursor-pointer !fixed"
        />
      </div>
    </div>
    <div class="inline-dialog !bg-white">
      <h2 class="sub-title">GENERAL INFORMATION</h2>

      <form [formGroup]="rfiForm" (ngSubmit)="createRFI()">
        <div class="grid grid-cols-2 gap-4">
          <!-- Subject -->
          <div class="col-span-2">
            <mat-form-field class="w-1/2" appearance="outline">
              <mat-label>Subject</mat-label>
              <input
                matInput
                type="text"
                formControlName="subject"
                placeholder="Enter Subject"
              />
              <mat-error
                *ngIf="
                  rfiForm.get('subject')?.invalid &&
                  rfiForm.get('subject')?.touched
                "
              >
                Subject is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-span-2">
            <app-rich-textEditor
              (contentChange)="addIssue($event)"
              [resetEditor]="resetRichTextEditor"
              [richTextValue]="rfiForm.get('issue')?.value"
              [placeHolder]="'Enter Issue'"
              [label]="'Description of the Issue'"
            ></app-rich-textEditor>
          </div>

          <div class="col-span-2">
            <app-rich-textEditor
              (contentChange)="addClarification($event)"
              [resetEditor]="resetRichTextEditor"
              [richTextValue]="rfiForm.get('clarification')?.value"
              [placeHolder]="'Enter Clarification'"
              [label]="'Request for Information / Clarification'"
            ></app-rich-textEditor>
          </div>
          <div class="flex flex-col items-start justify-center">
            <p class="file-label">Document Referenced Concerning the RFI</p>
            <app-file-manager
              [newFileControlName]="'rfiFiles'"
              [oldFiles]="oldRfiFiles"
              (newFilesUpdatedEvent)="handleNewFiles($event)"
              (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
            ></app-file-manager>
          </div>
          <div class="col-span-2">
            <app-rich-textEditor
              (contentChange)="addRecommendation($event)"
              [resetEditor]="resetRichTextEditor"
              [richTextValue]="rfiForm.get('recommendation')?.value"
              [placeHolder]="'Enter Recommendation'"
              [label]="'Recommendations (Optional)'"
            ></app-rich-textEditor>
          </div>

          <div class="col-span-2">
            <mat-form-field class="w-1/2" appearance="outline">
              <mat-label>Required response Date</mat-label>
              <input
                matInput
                [matDatepicker]="responseDate"
                formControlName="responseDate"
                placeholder="Required response Date"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="responseDate"
              ></mat-datepicker-toggle>
              <mat-datepicker #responseDate startView="year"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="dialog-actions sticky bottom-0 left-0 !bg-[white]">
          <div class="w-[100%] flex justify-end items-center">
            <div class="flex justify-start items-center">
              <button
                (click)="previousStep()"
                type="button"
                class="back-btn mr-[10px]"
              >
                Back
              </button>
              <button
                class="submit-btn"
                type="submit"
                [disabled]="rfiForm.invalid"
              >
                Create RFI
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
